export default "__VITE_ASSET__Dgq_Kj5v__"